"use strict";
var PerfectScrollbarConfig = (function () {
    function PerfectScrollbarConfig(config) {
        if (config === void 0) { config = {}; }
        this.assign(config);
    }
    PerfectScrollbarConfig.prototype.assign = function (config) {
        if (config === void 0) { config = {}; }
        for (var key in config) {
            this[key] = config[key];
        }
    };
    return PerfectScrollbarConfig;
}());
exports.PerfectScrollbarConfig = PerfectScrollbarConfig;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-perfect-scrollbar/dist/lib/perfect-scrollbar.interfaces.js
// module id = 10
// module chunks = 0 1